import React, { createContext, useContext, useEffect, useState } from 'react';
import { getContent } from '@/lib/api';

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const data = await getContent();
      setContent(data);
    } catch (e) {
      console.error('Failed to load content', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const ctx = useContext(ContentContext);
  return ctx || { content: null, loading: true, refresh: () => {} };
};
